<template>
  <div class="present d-flex align-center justify-center">
    <div class="present-content d-flex f-column align-center justify-center">
      <h3>企业介绍</h3>
      <p>我们的宗旨与优势</p>
      <div class="main d-flex align-center">
        <div class="desc">
          <p>
            国农，未来的农业大数据独角兽企业
          </p>
          <p>
            国农（重庆）生猪大数据产业发展有限公司（简称“国农”）成立于2020年，是全国业务类的商业二类国有企业。国农致⼒于⽣猪产业⼤数据领域的研发和创新，旨在成为全国⼀流的推动数字农业经济发展的创新企业。
          </p>
          <p>
            国家级⽣猪⼤数据中⼼由全国畜牧总站与重庆市 荣昌区共同成⽴，是农业农村部2019年4⽉批准建设的全国⾸个单⼀的畜牧单品种国家级⼤数据服务平台，已纳⼊《成渝地区双城经济圈建设规划纲要》。该中⼼按照“国家平台、⽣猪品牌、公益主体、产业 创新、服务市场、造福三农”的⽬标定位，重点围绕“业务指导、数据交换、数据应⽤、种业创新、信息发布、⼈才交流”等⽅⾯开展⼯作，致⼒于推动⽣猪产业数字化、数字产业化。国农作为国家级⽣猪⼤数据中⼼的建设和运营主体，贯彻落实国家关于“互联⽹+农业”、产业智能化升级等相关⽅针政策，以⽣猪产业数字化为⽬标导向，依托“5+3”发展战略，提供区块链应⽤、数字监控、数字监管、智能设备集成、⽣猪产业⾦融服务、⾏业咨询及品牌营销等产品解决⽅案及服务，助⼒农业数字化、智能化转型升级。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.present {
  padding-top: 1.25rem;
  padding-bottom: 1.225rem;
  background-color: #f9fafe;
  &-content {
    h3 {
      font-size: 0.45rem;
      padding-bottom: 0.375rem;
    }
    p {
      font-size: 0.2rem;
      color: #666;
      margin-bottom: 0.825rem;
    }
    .main {
      justify-content: flex-end;
      width: 15rem;
      height: 6.5rem;
      background: url('../../../assets/images/about_bg.jpg') no-repeat;
      background-size: 10rem 6.5rem;
      .desc {
        width: 7.5rem;
        height: 6.5rem;
        background-color: #fff;
        padding: 0.625rem 0.6rem;
        p {
          line-height: 0.375rem;
          font-size: 0.1875rem;
          color: #999;
          margin-bottom: 0;
          text-indent: 2em;
        }
      }
    }
  }
}
</style>
